import { Tabs, TabsList, TabsTrigger } from './tabs'

interface Tab {
  value: string
  label: string
}

interface UnderlineTabsProps {
  tabs: Tab[]
  value: string
  onValueChange: (value: string) => void
  className?: string
}

export function UnderlineTabs({ tabs, value, onValueChange, className }: UnderlineTabsProps) {
  return (
    <Tabs value={value} onValueChange={onValueChange} className={className}>
      {/* Scrolls rather than pushing the page wide: three or four tabs outrun a phone. */}
      <TabsList
        variant="line"
        className="no-scrollbar max-w-full justify-start gap-4 overflow-x-auto border-b border-b-transparent"
      >
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            className="text-muted-foreground data-[state=active]:border-b-accent-cyan data-[state=active]:text-foreground text-md shrink-0 rounded-none border-b-2 border-b-transparent px-1 pb-2 shadow-none! after:hidden"
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}
